import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '../../../components/SnackbarProvider';
import { HeapService, TranslatedComplaintReportHeapDetections, TranslatedField } from '../../generated';

interface SubmitComplaintProps {
  jobsiteId: string | undefined;
  title: string;
  recordedAt: Date;
  datetime: TranslatedField;
  licensePlate: TranslatedField;
  text: TranslatedField;
  detections: TranslatedComplaintReportHeapDetections;
}

export function useSubmitComplaint() {
  const { showSnackbar } = useSnackbar();
  return useMutation({
    mutationFn: async ({
      jobsiteId,
      title,
      recordedAt,
      datetime,
      licensePlate,
      text,
      detections,
    }: SubmitComplaintProps) => {
      if (!jobsiteId || !recordedAt || !detections) {
        throw new Error('Missing required fields');
      }

      const response = await HeapService.heapControllerSubmitComplaint({
        path: {
          jobsiteId,
        },
        body: {
          title,
          recordedAt: recordedAt.toISOString(),
          datetime,
          licensePlate,
          text,
          detections,
        },
      });

      if (response.error) throw Error();
    },
    onSuccess: () => {
      showSnackbar('heap.complaint.submitSuccess', 'success');
    },
    onError: () => {
      showSnackbar('heap.complaint.submitError', 'error');
    },
  });
}
